import { AbsenceDayPosition } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

export const borderRadiusByPosition: Record<AbsenceDayPosition, string> = {
  [AbsenceDayPosition.SINGLE]: "0.5rem",
  [AbsenceDayPosition.START]: "0.5rem 0 0 0.5rem",
  [AbsenceDayPosition.MIDDLE]: "0",
  [AbsenceDayPosition.END]: "0 0.5rem 0.5rem 0",
};

// How far the colored background bleeds into adjacent 2px gaps
export const bleedByPosition: Record<
  AbsenceDayPosition,
  { left: string; right: string }
> = {
  [AbsenceDayPosition.SINGLE]: { left: "0px", right: "0px" },
  [AbsenceDayPosition.START]: { left: "0px", right: "-2px" },
  [AbsenceDayPosition.MIDDLE]: { left: "-2px", right: "-2px" },
  [AbsenceDayPosition.END]: { left: "-2px", right: "0px" },
};
